@if (isVisible()) {
  <div [id]="navLink.id" class="udex-grid udex-mx-auto udex-mb-32 udex-lg-mb-0 col-12 col-lg-9">
    <h2 class="heading__regular--l text-center udex-mb-32">
      {{ 'productDetails.technicalInformation' | cxTranslate }}
    </h2>

    <p class="text-center udex-mb-20" id="benefits-and-features">
      {{ 'productDetails.providedByPublisher' | cxTranslate }}
    </p>

    <udex-accordion class="udex-mb-20">
      @if (hasGeneral) {
        <udex-accordion-item [attr.label]="'productDetails.general' | cxTranslate" expanded>
          @if (product) {
            <dcp-classifications-template
              [parentTechnicalInformationComponent]="true"
              [productClassifications]="productClassifications"
              [product]="product"
            ></dcp-classifications-template>
          }
        </udex-accordion-item>
      }
      @for (section of sections; track section.header) {
        <udex-accordion-item [attr.label]="section.header | cxTranslate">
          @for (value of section.data; track $index; let h = $index) {
            @let mid = half(section.data.length);
            @if (h < mid) {
              <div class="row mx-0">
                <div class="col-12 col-sm-6">
                  <div [class.mt-5]="h !== 0" class="d-flex text-black">
                    <ui5-icon class="icon udex-me-4 udex-mb-8" name="accept" accessible-name="Checked"
                      aria-hidden="true"></ui5-icon>
                    <div class="heading__regular--xxxxs">{{ value.header }}</div>
                  </div>
                  <div class="body--s">{{ value.val }}</div>
                </div>
                <div class="col-12 col-sm-6">
                  @if (section.data[mid + h]) {
                    <div [class.mt-sm-0]="h === 0" class="d-flex text-black mt-5">
                      <ui5-icon class="icon udex-me-8 udex-mb-8" name="accept" accessible-name="Checked"
                        aria-hidden="true"></ui5-icon>
                      <div class="heading__regular--xxxxs">{{ section.data[mid + h].header }}</div>
                    </div>
                    <div class="body--s">{{ section.data[mid + h].val }}</div>
                  }
                </div>
              </div>
            }
          }
        </udex-accordion-item>
      }
    </udex-accordion>
  </div>

  <div class="udex-legacy-shadow d-none d-lg-block udex-my-32"></div>
}
